import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ConstantsService } from "../services/constants.service";
// import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-thanks-popup',
  templateUrl: './thanks-popup.component.html',
  styleUrls: ['./thanks-popup.component.scss']
})
export class ThanksPopupComponent implements OnInit {
  @Output() onclickClose =new EventEmitter();
  constructor(public constants: ConstantsService) { }

  ngOnInit(): void {
  }
  closeBookmarkAlert_2() {
    this.onclickClose.emit('close button was clicked');
  }
}
